import React from 'react';
import UserLinkService from '../Services/UserLinkService';
import UserLinkItem from '../Domain/UserLinkItem';
import InputTypesEnum from '../Enums/InputTypesEnum';
import ValidityHelper from '../Helpers/ValidityHelper';
import AuthService from '../Services/authService';

export default class EditUserLinkWindowDescription extends React.Component
{
  static titleForCreate = 'New User Link';
  static titleForEdit = 'Edit User Link';
  static itemType = UserLinkItem;
  static serviceFunction = (edited) => UserLinkService.UpsertUserLink(edited);

  getSelected () { }

  getSearchParameters () { }

  getAllItemInTheSearchAreSelected () { }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Title',
          label: 'Title *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (item) => ValidityHelper.forRequiredAndMaxLengthField(item, 50),
        },
        {
          fieldName: 'Text',
          label: 'Text *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (item) => ValidityHelper.forRequiredAndMaxLengthField(item, 200),
        },
        {
          fieldName: 'Url',
          label: 'URL *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Active?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Target',
          label: 'Target',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditUserLinkWindowDescription.getTargetOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Order',
          label: 'Order',
          className: 'col-12',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'UserGuidId',
          label: 'User',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserSelectWithGuid,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.HasAdminRole,
        },
        {
          fieldName: 'ForeColor',
          label: 'Text Color',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditUserLinkWindowDescription.getForeColorOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'BackColor',
          label: 'Background Color',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditUserLinkWindowDescription.getBackColorOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getTargetOptions ()
  {
    return [
      { value: '_self', label: 'Same Tab' },
      { value: '_blank', label: 'New Tab' },
    ];
  }

  static getForeColorOptions ()
  {
    return [
      { value: 'dark', label: 'Black' },
      { value: 'secondary', label: 'Gray' },
      { value: 'primary', label: 'Blue' },
      { value: 'info', label: 'Light Blue' },
      { value: 'success', label: 'Green' },
      { value: 'danger', label: 'Red' },
      { value: 'warning', label: 'Yellow' },
      { value: 'light', label: 'White' },
    ];
  }

  static getBackColorOptions ()
  {
    return [
      { value: 'light', label: 'White' },
      { value: 'secondary', label: 'Gray' },
      { value: 'primary', label: 'Blue' },
      { value: 'info', label: 'Light Blue' },
      { value: 'success', label: 'Green' },
      { value: 'danger', label: 'Red' },
      { value: 'warning', label: 'Yellow' },
      { value: 'dark', label: 'Black' },
    ];
  }
}
